import React, { useState, useMemo, useEffect } from "react";
import {
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  FormGroup,
  Form,
  Alert,
  Spinner,
} from "reactstrap";
import { Table, Button, Label, Input, Row } from "reactstrap";
import * as FaIcons from "react-icons/fa";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import "jspdf-autotable";
import logos from "../../components/img/base/111.png";
import axios from "axios";
import "../Bec/bec.scss";
import Swal from "sweetalert2";

function Informe2() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState({
    id_doc: "",
    id_bec: "",
    nom_doc: "",
    nom_usu: "",
    archivo_per: null,
    f_cargado: "",
  });
  // Definir un objeto de validación con patrones de expresiones regulares y estados de validación iniciales
  const validation = {
    id_doc: { regex: /^[a-zA-Z\s]{1,20}$/, isValid: true },
    nom_doc: { regex: /^[a-zA-Z\s]{1,20}$/, isValid: true },
    nom_usu: { regex: /^[a-zA-Z\s]{1,20}$/, isValid: true },
    f_cargado: { isValid: false },
    archivo_per: { isValid: false },
  };

  const [isValid, setIsValid] = useState({
    id_doc: true,
    nom_doc: true,
    nom_usu: true,
    f_cargado: true,
    archivo_per: false,
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "f_cargado") {
      // Manejar cambio de fecha y hora
      setUsuarioSeleccionado((prevState) => ({ ...prevState, [name]: value }));
      const isValidValue = value !== "";
      setIsValid((prevState) => ({ ...prevState, [name]: isValidValue }));
    } else {
      // Manejar cambio de texto
      setUsuarioSeleccionado((prevState) => ({ ...prevState, [name]: value }));
      if (validation[name] && validation[name].regex) {
        const isValidValue = validation[name].regex.test(value);
        setIsValid((prevState) => ({ ...prevState, [name]: isValidValue }));
      }
    }
  };
  //modal insertar
  const [modalInsertar, setModalInsertar] = useState(false);
  const abrirCerrarModalInsertar = () => {
    setModalInsertar(!modalInsertar);
  };
  //modal eliminar
  const [modalEliminar, setModalEliminar] = useState(false);
  const abrirCerrarModalEliminar = () => {
    setModalEliminar(!modalEliminar);
  };
  //modal ver
  const [modalVer, setModalVer] = useState(false);
  const abrirCerrarModalVer = () => {
    setModalVer(!modalVer);
  };
  ////Modal REPORTE INFORMES
  const [modalVerInf, setModalVerInf] = useState(false);
  const abrirCerrarModalVerInf = () => {
    setModalVerInf(!modalVerInf);
  };

  const baseUrl = "https://bqef-bo.com/api/A/apiDash.php";
  ////Datos usuario Administrador
  const [dataAdm, setDataAdm] = useState({});
  const peticionGetAdm = async () => {
    setLoading(true);
    setError("");
    const adminId = sessionStorage.getItem("iduser");
    try {
      const res = await axios.get(`${baseUrl}?action=getInfoAdm&id=${adminId}`);
      const receivedData =
        res.data.InfoAdm && Array.isArray(res.data.InfoAdm)
          ? res.data.InfoAdm
          : [];
      // console.log(res.data);
      setDataAdm(receivedData);
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ha ocurrido un error al cargar los datos.",
        footer: `Código de error: ${error.response.status}`,
      });
    }
  };
  /////Listado informes
  const [data, setData] = useState([]);
  const peticionGet = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axios.get(`${baseUrl}?action=getInfo`);
      const receivedData =
        res.data.Informes && Array.isArray(res.data.Informes)
          ? res.data.Informes
          : [];
      // console.log(receivedData);
      setTablaUsuarios(receivedData);
      setData(receivedData);
    } catch (error) {
      console.error(error);
      setError("Error al cargar los datos");
    } finally {
      setLoading(false);
    }
  };
  /////Cargar informes
  const [informe, setInforme] = useState(null);
  async function cargarinfo(e) {
    e.preventDefault();
    let fd = new FormData();
    fd.append("archivo_per", informe);
    fd.append("nom_usu", usuarioSeleccionado.nom_usu);
    fd.append("nom_doc", usuarioSeleccionado.nom_doc);
    fd.append("f_cargado", usuarioSeleccionado.f_cargado);

    // Acceder directamente a la primera posición del array
    if (Array.isArray(dataAdm) && dataAdm.length > 0 && dataAdm[0].id_adm) {
      const idAdm = dataAdm[0].id_adm;
      fd.append("usu_creacion", idAdm);
    } else {
      console.error("No se encontró id_adm");
      return; // Detener envío si no hay id_adm
    }

    try {
      // const res =
      await axios.post(`${baseUrl}?action=addInf`, fd);
      // console.log(res.data);
      abrirCerrarModalInsertar();
      mostrarAlertaN();
      peticionGet();
    } catch (error) {
      console.log(error.response.data);
      mostrarAlertaError();
    }
  }

  /////Eliminar informe
  async function deleteImagen(id_doc) {
    const idAdm =
      Array.isArray(dataAdm) && dataAdm.length > 0 ? dataAdm[0].id_adm : null;

    if (!idAdm) {
      console.error("No se encontró id_doc para eliminar");
      return;
    }

    try {
      // const res =
      await axios.delete(
        `${baseUrl}?action=deleteInf&id_doc=${id_doc}&usu_modificacion=${idAdm}`
      );
      abrirCerrarModalEliminar();
      peticionGet();
      mostrarAlertaD();
      // console.log(res.data);
    } catch (error) {
      console.error("Error en peticionDelete:", error);
    }
  }

  const seleccionarUsuario = (Usuario, caso) => {
    setUsuarioSeleccionado(Usuario);

    caso === "Visualizar" ? abrirCerrarModalVer() : abrirCerrarModalEliminar();
  };

  ////Descargar informes en PDF
  const handleDescargarPdf = async () => {
    var link = document.createElement("a");
    // Se agregan los prefijos de href para indicar que el contenido que sigue está en formato PDF y
    // está codificado en Base64.
    link.setAttribute(
      "href",
      "data:application/pdf;base64," + usuarioSeleccionado.archivo_per
    );
    link.setAttribute("download", usuarioSeleccionado.nom_doc);
    link.click();
  };

  useEffect(() => {
    peticionGet();
    peticionGetAdm();
  }, []);
  // Estado
  const [dataRes, setDataRes] = useState([]);
  const [dataRes2, setDataRes2] = useState([]);

  // Función para obtener datos
  async function peticionResumenDatos() {
    try {
      const res = await axios.get(`${baseUrl}?action=getInfo`);
      // console.log("Datos recibidos:", res.data);
      setDataRes(res.data);

      if (
        res.data.informes_responsables &&
        Array.isArray(res.data.informes_responsables)
      ) {
        setDataRes2(res.data.informes_responsables);
      } else {
        setDataRes2([]);
      }
    } catch (error) {
      console.error("Error al obtener los datos:", error);
    }
  }

  // Ejecutar al cargar
  useEffect(() => {
    peticionResumenDatos();
  }, []);
  ////BARRA BUSQUEDA
  const [busqueda, setBusqueda] = useState("");
  const [tablaUsuarios, setTablaUsuarios] = useState([]);

  const handleChangeB = (e) => {
    setBusqueda(e.target.value);
    filtrar(e.target.value);
  };

  const filtrar = (terminoBusqueda) => {
    const resultadosBusqueda = tablaUsuarios.filter(
      (elemento) =>
        elemento.nom_doc
          .toString()
          .toLowerCase()
          .includes(terminoBusqueda.toLowerCase()) ||
        elemento.nom_usu
          .toString()
          .toLowerCase()
          .includes(terminoBusqueda.toLowerCase())
    );
    setData(resultadosBusqueda);
  };
  ////ALERTAS
  const mostrarAlertaN = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Éxito!",
      text: "Documento cargado",
      timer: 5000,
      icon: "success",
    });
  };
  const mostrarAlertaError = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Error!",
      text: "No se pudo cargar.",
      timer: 5000,
      icon: "danger",
    });
  };
  const mostrarAlertaD = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Eliminado!",
      text: "Documento Eliminado.",
      timer: 5000,
      icon: "success",
    });
  };
  // Estado para ordenamiento
  const [sortField, setSortField] = useState(null);
  const [order, setOrder] = useState("asc");

  // Estado para filtro por nombre de documento
  const [filterNomDoc, setFilterNomDoc] = useState("");

  // Función para manejar ordenamiento
  const handleSortingChange = (accessor) => {
    const sortOrder =
      accessor === sortField && order === "asc" ? "desc" : "asc";
    setSortField(accessor);
    setOrder(sortOrder);
  };

  // Datos filtrados y ordenados para vista
  const filteredAndSortedData = useMemo(() => {
    // Filtrar por nom_doc
    const filteredData = data.filter((item) => {
      return !filterNomDoc || item.nom_doc === filterNomDoc;
    });

    // Ordenar
    if (!sortField) return filteredData;

    const dataCopy = [...filteredData];
    dataCopy.sort((a, b) => {
      if (a[sortField] < b[sortField]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortField] > b[sortField]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    return dataCopy;
  }, [data, filterNomDoc, sortField, order]);

  // Datos solo filtrados por nom_doc para PDF
  const dataForPDF = useMemo(() => {
    return data.filter((item) => {
      return !filterNomDoc || item.nom_doc === filterNomDoc;
    });
  }, [data, filterNomDoc]);
  ///GENERAR PDF INFORME
  const generatePDFI = () => {
    // Crear un nuevo documento PDF en orientación horizontal (landscape)
    const doc = new jsPDF("portrait");

    // Propiedades del documento (puedes incluir título, autor, etc.)
    doc.setProperties({
      title: "Seguimiento Informes",
      author: "BQEF",
      subject: "Reporte de datos",
      keywords: "seguimiento informes, reporte, datos",
      creator: "jsPDF",
    });

    // Agregar logo al documento PDF
    doc.addImage(logos, "PNG", 10, 10, 20, 10);

    // Establecer la fuente en negrita
    doc.setFont("helvetica", "bold");

    // Agregar título "FONDO DE EDUCACIÓN" al documento PDF
    doc.setFontSize(12);
    const title = "FONDO DE EDUCACION DE CUAQUEROS BOLIVIANOS";
    const titleWidth = doc.getTextWidth(title);
    const x = (doc.internal.pageSize.width - titleWidth) / 2; // Calcular posición X para centrar
    const y = 20; // Posición Y del título

    // Escribir el título
    doc.text(title, x, y);

    // Dibujar la línea subrayando el título
    doc.line(x, y + 1, x + titleWidth, y + 1); // Dibuja la línea

    // Restablecer la fuente a normal
    doc.setFont("helvetica", "normal");

    // Agregar subtítulo "Reporte" al documento PDF
    const subtitle = "Reporte Informes";
    const subtitleWidth = doc.getTextWidth(subtitle);
    const subtitleX = (doc.internal.pageSize.width - subtitleWidth) / 2; // Calcular posición X para centrar
    doc.text(subtitle, subtitleX, 30);

    // Agregar fecha al documento PDF
    const fecha = new Date();
    const dia = fecha.getDate();
    const mes = fecha.getMonth() + 1;
    const año = fecha.getFullYear();
    doc.setFontSize(9);
    doc.text(`Fecha: ${dia}/${mes}/${año}`, 10, 25);

    // Establecer la fuente en negrita
    doc.setFont("helvetica", "bold");

    // Definir el texto "Usuario: "
    const usuarioText = "Usuario: Administrador Sistema";

    // Calcular el ancho del texto
    const usuarioWidth = doc.getTextWidth(usuarioText);

    // Calcular la posición X para alinearlo a la derecha
    const usuarioX = doc.internal.pageSize.width - usuarioWidth - 10; // 10 mm de margen desde el borde derecho

    // Escribir el texto "Usuario:" en la posición calculada
    doc.text(usuarioText, usuarioX, 35);

    const userData = [];

    // Recorrer dataF y dataFI para llenar tableData

    const fechaActual = new Date(dataRes.ultimo_fecha_ent.fecha);

    dataRes2.forEach((item, n1) => {
      const fechaDocumento = new Date(item.f_cargado);
      const fnull = new Date(0);

      let estado = "";
      let analisis = ""; // Nueva variable para el análisis

      if (fechaDocumento.toISOString() === fechaActual.toISOString()) {
        estado = "ENTREGADO";
        analisis = "Aprobado"; // Asignar texto correspondiente
      } else if (fechaDocumento > fechaActual) {
        estado = "RETRASO";
        analisis = "Advertencia"; // Asignar texto correspondiente
      } else if (fechaDocumento.toISOString() === fnull.toISOString()) {
        estado = "PENDIENTE";
        analisis = "Tomar en cuenta retiro"; // Asignar texto correspondiente
      } else {
        estado = "ENTREGADO";
        analisis = "Aprobado"; // Asignar texto correspondiente
      }

      // Agregar los datos a la tabla
      userData.push([
        n1 + 1,
        item.responsable,
        item.nom_doc,
        item.f_cargado,
        estado,
        analisis, // Agregar el análisis a la fila
      ]);
    });

    // Definir los encabezados de la tabla
    const headers = [
      "#",
      "Responsable",
      "Nombre del Documento",
      "Fecha Cargado",
      "Estado",
      "Análisis Sist.",
    ];

    // Agregar encabezados y datos a la tabla
    autoTable(doc, {
      head: [headers],
      body: userData,
      didParseCell: (data) => {
        // Solo cambiar el fondo de la celda del estado
        if (data.column.index === 4) {
          // Verificar que estamos en la columna de estado
          const estado = data.cell.raw; // Obtener el valor de la celda
          if (estado === "ENTREGADO") {
            data.cell.styles.fillColor = [46, 139, 87]; // RGB para el color
            data.cell.styles.textColor = [255, 255, 255]; // Texto en blanco
          } else if (estado === "RETRASO") {
            data.cell.styles.fillColor = [219, 146, 46]; // RGB para el color
            data.cell.styles.textColor = [255, 255, 255]; // Texto en blanco
          } else if (estado === "PENDIENTE") {
            data.cell.styles.fillColor = [205, 92, 92]; // RGB para el color
            data.cell.styles.textColor = [255, 255, 255]; // Texto en blanco
          }
        }

        // Cambiar el color del texto en la columna de análisis
        if (data.column.index === 5) {
          // Verificar que estamos en la columna de análisis
          const analisis = data.cell.raw; // Obtener el valor de la celda
          if (analisis === "Aprobado") {
            data.cell.styles.textColor = [0, 128, 0];
          } else if (analisis === "Advertencia") {
            data.cell.styles.textColor = [219, 146, 46];
          } else if (analisis === "Tomar en cuenta retiro") {
            data.cell.styles.textColor = [255, 0, 0];
          }
        }
      },
      startY: 40,
      margin: { top: 20, bottom: 20 },
      bodyStyles: { fontSize: 8 },
      headStyles: { fontSize: 9, fillColor: [10, 49, 67] },
    });

    // Agregar número de página al documento PDF
    let totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(9);
      doc.text(
        `Página ${i} de ${totalPages}`,
        10,
        doc.internal.pageSize.height - 10
      );
    }

    // Convertir el documento PDF a blob
    const pdfBlob = doc.output("blob");

    // Abrir el PDF en una nueva ventana
    const url = URL.createObjectURL(pdfBlob);
    window.open(url, "_blank");
  };
  ///GENERAR PDF INFORME
  const generatePDF = (datos) => {
    // Crear un nuevo documento PDF en orientación horizontal (landscape)
    const doc = new jsPDF("portrait");

    // Propiedades del documento (puedes incluir título, autor, etc.)
    doc.setProperties({
      title: "Reporte Informe Cargados",
      author: "BQEF",
      subject: "Reporte de datos",
      keywords: "becarios informes, reporte, datos",
      creator: "jsPDF",
    });

    // Agregar logo al documento PDF
    doc.addImage(logos, "PNG", 10, 10, 20, 10);

    // Establecer la fuente en negrita
    doc.setFont("helvetica", "bold");

    // Agregar título "FONDO DE EDUCACIÓN" al documento PDF
    doc.setFontSize(12);
    const title = "FONDO DE EDUCACION DE CUAQUEROS BOLIVIANOS";
    const titleWidth = doc.getTextWidth(title);
    const x = (doc.internal.pageSize.width - titleWidth) / 2; // Calcular posición X para centrar
    const y = 20; // Posición Y del título

    // Escribir el título
    doc.text(title, x, y);

    // Dibujar la línea subrayando el título
    doc.line(x, y + 1, x + titleWidth, y + 1); // Dibuja la línea

    // Restablecer la fuente a normal
    doc.setFont("helvetica", "normal");

    // Agregar subtítulo "Reporte" al documento PDF
    const subtitle = "Reporte Informe Cargados";
    const subtitleWidth = doc.getTextWidth(subtitle);
    const subtitleX = (doc.internal.pageSize.width - subtitleWidth) / 2; // Calcular posición X para centrar
    doc.text(subtitle, subtitleX, 30);

    // Agregar fecha al documento PDF
    const fecha = new Date();
    const dia = fecha.getDate();
    const mes = fecha.getMonth() + 1;
    const año = fecha.getFullYear();
    doc.setFontSize(9);
    doc.text(`Fecha: ${dia}/${mes}/${año}`, 10, 25);

    // Establecer la fuente en negrita
    doc.setFont("helvetica", "bold");

    // Definir el texto "Usuario: "
    const usuarioText = "Usuario: Personal Administrativo";

    // Calcular el ancho del texto
    const usuarioWidth = doc.getTextWidth(usuarioText);

    // Calcular la posición X para alinearlo a la derecha
    const usuarioX = doc.internal.pageSize.width - usuarioWidth - 10; // 10 mm de margen desde el borde derecho

    // Escribir el texto "Usuario:" en la posición calculada
    doc.text(usuarioText, usuarioX, 35);

    // Preparar datos para la tabla
    const userData = datos
      .map((item, index) => ({
        it: index + 1,
        nom_d: item.nom_doc,
        nom_u: item.nom_usu,
        id_bec: item.id_bec,
        f_cargado: item.f_cargado,
      }))
      .sort((a, b) => a.nom_d.localeCompare(b.nom_d));

    // Definir las columnas de la tabla
    const columns = [
      { header: "N°", dataKey: "it" },
      { header: "Nombre Documento", dataKey: "nom_d" },
      { header: "Nombre Usuario", dataKey: "nom_u" },
      { header: "ID Usuario", dataKey: "id_bec" },
      { header: "Fecha Cargado", dataKey: "f_cargado" },
    ];

    // Restablecer la fuente a normal
    doc.setFont("helvetica", "normal");

    // Agregar la tabla al documento PDF
    autoTable(doc, {
      columns: columns,
      body: userData,
      startY: 40,
      margin: { top: 20, bottom: 20 },
      bodyStyles: { fontSize: 8 },
      headStyles: { fontSize: 9, fillColor: [10, 49, 67] },
    });

    // Agregar número de página al documento PDF
    let totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(9);
      doc.text(
        `Página ${i} de ${totalPages}`,
        10,
        doc.internal.pageSize.height - 10
      );
    }

    // Convertir el documento PDF a blob
    const pdfBlob = doc.output("blob");

    // Abrir el PDF en una nueva ventana
    const url = URL.createObjectURL(pdfBlob);
    window.open(url, "_blank");
  };
  ////Carga
  if (loading) {
    return (
      <div className="text-center my-5">
        <Spinner color="primary" />
        Cargando...
      </div>
    );
  }

  if (error) {
    return <Alert color="danger">{error}</Alert>;
  }
  return (
    <div id="main_content">
      <div className="tra">
        <div className="tra title-form">
          <h2>Listado Informes</h2>
        </div>
        <div className="frm">
          <Button
            color="success"
            size="lg"
            onClick={() => abrirCerrarModalInsertar()}
          >
            <FaIcons.FaPlus /> Añadir
          </Button>
          &nbsp;&nbsp;
          <Button
            color="primary"
            size="lg"
            onClick={() => generatePDF(dataForPDF)}
          >
            <FaIcons.FaFileDownload /> Reporte
          </Button>
          &nbsp;&nbsp;
          <Button
            color="secondary"
            size="lg"
            onClick={() => abrirCerrarModalVerInf()}
          >
            <FaIcons.FaFileDownload /> Seguimiento
          </Button>
        </div>
        <div className="frm containerInput">
          <Input
            className="form-control inputBuscar"
            bsSize="lg"
            value={busqueda}
            placeholder="Búsqueda por Nombre documento o Nombre usuario"
            onChange={handleChangeB}
          />
          <Button className="btn btn-success" size="lg">
            <FaIcons.FaSearch /> Buscar
          </Button>
        </div>
        <div className="frm">
          {/* Selector para filtrar por nom_doc */}
          <label>Filtrar por Documento:</label>&nbsp;&nbsp;
          <select
            value={filterNomDoc}
            onChange={(e) => setFilterNomDoc(e.target.value)}
            style={{ marginRight: "10px" }}
          >
            <option value="">Todos</option>
            {[...new Set(data.map((item) => item.nom_doc))].map((doc, idx) => (
              <option key={idx} value={doc}>
                {doc}
              </option>
            ))}
          </select>
          {/* Si quieres otro filtro, agregalo aquí */}
        </div>
        <Table className="frm" responsive="sm" id="tabl">
          <thead id="stahead">
            <tr>
              {/* Encabezado con ordenamiento */}
              <th>N°</th>
              <th
                onClick={() => handleSortingChange("nom_usu")}
                style={{ cursor: "pointer" }}
              >
                Usuario{" "}
                {sortField === "nom_usu" ? (
                  order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : (
                    <FaIcons.FaSortDown />
                  )
                ) : (
                  <FaIcons.FaSort />
                )}
              </th>
              <th
                onClick={() => handleSortingChange("nom_doc")}
                style={{ cursor: "pointer" }}
              >
                Nombre documento{" "}
                {sortField === "nom_doc" ? (
                  order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : (
                    <FaIcons.FaSortDown />
                  )
                ) : (
                  <FaIcons.FaSort />
                )}
              </th>
              <th
                onClick={() => handleSortingChange("f_cargado")}
                style={{ cursor: "pointer" }}
              >
                Fecha Cargado{" "}
                {sortField === "f_cargado" ? (
                  order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : (
                    <FaIcons.FaSortDown />
                  )
                ) : (
                  <FaIcons.FaSort />
                )}
              </th>
              <th>Acciones</th>
              {/* Agrega otros encabezados si quieres */}
            </tr>
          </thead>
          <tbody>
            {filteredAndSortedData.map((item, index) => (
              <tr key={item.id || index}>
                <td>{index + 1}</td>
                <td>{item.nom_usu}</td>
                <td>{item.nom_doc}</td>
                <td>{item.f_cargado}</td>
                <td>
                  <Button
                    color="warning"
                    onClick={() => seleccionarUsuario(item, "Visualizar")}
                  >
                    <FaIcons.FaRegEye />
                    &nbsp;&nbsp;Visualizar
                  </Button>
                  &nbsp;&nbsp;&nbsp;
                  <Button
                    color="danger"
                    onClick={() => seleccionarUsuario(item, "Eliminar")}
                  >
                    Eliminar
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {/* Modal añadir informe */}
        <Modal isOpen={modalInsertar} toggle={abrirCerrarModalInsertar}>
          <ModalHeader className="header_mo">Cargar documento</ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Label>Nombre documento: </Label>
                <br />
                <Input
                  type="text"
                  className="form-control"
                  name="nom_doc"
                  value={usuarioSeleccionado.nom_doc}
                  onChange={handleChange}
                />
                {!isValid.nom_doc && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 20 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Usuario: </Label>
                <br />
                <Input
                  type="text"
                  className="form-control"
                  name="nom_usu"
                  value={usuarioSeleccionado.nom_usu}
                  onChange={handleChange}
                />
                {!isValid.nom_usu && (
                  <span style={{ color: "red" }}>
                    El texto debe tener como máximo 20 letras y espacios
                  </span>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Informe personal: </Label>
                <Input
                  type="file"
                  className="form-control"
                  accept="archivo_per/*"
                  onChange={(e) => setInforme(e.target.files[0])}
                  multiple
                />
                <br />
                <Label>Fecha cargado: </Label>
                <Input
                  type="date"
                  className="form-control"
                  name="f_cargado"
                  onChange={handleChange}
                />
                {!isValid.f_cargado && (
                  <span style={{ color: "red" }}>
                    Debe seleccionar una fecha y hora válida
                  </span>
                )}
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button
              color="success"
              size="lg"
              onClick={(e) => cargarinfo(e)}
              disabled={
                !isValid.nom_doc || !isValid.nom_usu || !isValid.f_cargado
              }
            >
              Guardar
            </Button>
            <Button
              color="danger"
              size="lg"
              onClick={() => abrirCerrarModalInsertar()}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>
        {/* Modal eliminar informe */}
        <Modal isOpen={modalEliminar} toggle={abrirCerrarModalEliminar}>
          <ModalHeader className="header_mo">
            Eliminar informe becario
          </ModalHeader>
          <ModalBody>
            ¿Estás seguro que deseas eliminar el informe{" "}
            {usuarioSeleccionado && usuarioSeleccionado.nom_doc}?
          </ModalBody>
          <ModalFooter>
            <Button
              color="success"
              size="lg"
              onClick={() => deleteImagen(usuarioSeleccionado.id_doc)}
            >
              Sí
            </Button>
            <Button
              color="danger"
              size="lg"
              onClick={() => abrirCerrarModalEliminar()}
            >
              No
            </Button>
          </ModalFooter>
        </Modal>

        {/* Modal VER */}
        <Modal
          isOpen={modalVer}
          toggle={abrirCerrarModalVer}
          size="lg"
          className="modal-responsive"
        >
          <ModalHeader className="header_mo">
            {usuarioSeleccionado && usuarioSeleccionado.nom_doc}
          </ModalHeader>
          <ModalBody className="p-0">
            <Card>
              <CardBody className="p-0">
                <Row className="justify-content-center">
                  <object
                    data={
                      "data:application/pdf;base64," +
                      usuarioSeleccionado.archivo_per
                    }
                    type="application/pdf"
                    alt="archivo_per"
                    style={{ width: "100%", height: "80vh" }} // Ajuste para dispositivos móviles
                  >
                    <p>
                      Tu navegador no puede mostrar este archivo PDF. Puedes
                      descargarlo
                      <a
                        href={
                          "data:application/pdf;base64," +
                          usuarioSeleccionado.archivo_per
                        }
                        download
                      >
                        aquí
                      </a>
                      .
                    </p>
                  </object>
                </Row>
              </CardBody>
            </Card>
          </ModalBody>
          <ModalFooter>
            <Button
              style={{ float: "right" }}
              color="success"
              size="lg"
              onClick={handleDescargarPdf}
            >
              <FaIcons.FaDownload />
              Descargar
            </Button>
          </ModalFooter>
        </Modal>
        {/* Modal VER REPORTE INFORMES*/}
        <Modal isOpen={modalVerInf} toggle={abrirCerrarModalVerInf} size="xl">
          <ModalHeader className="header_mo">
            Estado Informes Entregados
          </ModalHeader>
          <div className="frm">
            <Button color="primary" size="lg" onClick={generatePDFI}>
              <FaIcons.FaFileDownload /> Reporte
            </Button>
          </div>
          <ModalBody>
            <Table id="tabl">
              <thead id="stahead">
                <tr className="text-center tra title-form">
                  <th>N°</th>
                  <th>Nombre Becario</th>
                  <th>N. Documento</th>
                  <th>Fecha E.</th>
                  <th>Estado</th>
                </tr>
              </thead>
              <tbody>
                {dataRes2.length > 0 ? (
                  dataRes2.map((itemF, index) => {
                    // Validar que dataRes y dataRes.ultimo_fecha_ent existan
                    const fechaActual =
                      dataRes && dataRes.ultimo_fecha_ent
                        ? new Date(dataRes.ultimo_fecha_ent.fecha)
                        : null;

                    const fechaDocumento = new Date(itemF.f_cargado);
                    const fnull = new Date(0);

                    let estado = "";
                    let color = "";

                    if (fechaActual) {
                      if (
                        fechaDocumento.toISOString() ===
                        fechaActual.toISOString()
                      ) {
                        estado = "ENTREGADO";
                        color = "#2E8B57";
                      } else if (fechaDocumento > fechaActual) {
                        estado = "RETRASO";
                        color = "#db922e";
                      } else if (
                        fechaDocumento.toISOString() === fnull.toISOString()
                      ) {
                        estado = "PENDIENTE";
                        color = "#CD5C5C";
                      } else {
                        estado = "ENTREGADO";
                        color = "#2E8B57";
                      }
                    } else {
                      // Caso en que no hay fechaActual
                      estado = "SIN FECHA";
                      color = "#999"; // gris
                    }

                    return (
                      <tr className="text-center" key={itemF.id_fech}>
                        <td>{index + 1}</td>
                        <td>{itemF.responsable}</td>
                        <td>{itemF.nom_doc}</td>
                        <td>{itemF.f_cargado}</td>
                        <td
                          align="center"
                          style={{ color: "white", backgroundColor: color }}
                        >
                          {estado}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="5">No hay datos para mostrar</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </ModalBody>
          <ModalFooter>
            <Button
              color="danger"
              size="lg"
              onClick={() => abrirCerrarModalVerInf()}
            >
              Cerrar
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
}

export default Informe2;
